import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import moment from "moment";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { sweetAlert } from "../../../Common/Utills/Utills";
import AddProductDetailsModal from "./AddProductDetailsModal";
import UpdateProductDetailsModal from "./UpdateProductDetailsModal";
import UpdateYardDetailsModal from "./UpdateYardDetailsModal";
import Pagination from "../../../Common/Pagination/Pagination";
import { CSSTransition } from "react-transition-group";
import YardQtyDetails from "./YardQtyDetails";
import _ from "lodash";
import { minDate } from "../../../Constants/Constants";

const ProductDetails = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [company, setCompany] = useState([]);
  const [product, setProduct] = useState([]);
  const [productId, setProductId] = useState("");
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const [rowAddData, setRowAddData] = useState({
    company_id: "",
    party_name_id: "",
    material_id: "",
    product_id: "",
    incoming_stock: "",
  });
  const formRef = useRef(null);

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };

  // Add a function to handle page size change
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };
  const [filterCriteria, setfilterCriteria] = useState({
    company_id: selectedCompanyId,
    product_name_id: productId,
    date: "",
    start_date: "",
    end_date: "",
  });

  const handleFilterChange = (name, value) => {
    setfilterCriteria(() => {
      return {
        ...filterCriteria,
        [name]: value,
      };
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setselectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { product_name, quantity, size, date } = rowAddData;
    const renewalDate = moment.utc(date, "YYYY-MM-DD").toISOString();
    let BASE_URL =
      SERVER_URL + `/api/product-details/product-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        product_name,
        quantity,
        size,
        date: renewalDate,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/product-details/all-product-details/${user_id}?company_id=${
        filterCriteria.company_id
      }&product_name_id=${filterCriteria.product_name_id}&start_date=${
        filterCriteria.start_date
      }&end_date=${filterCriteria.end_date}&skip=${
        (currentPage - 1) * pageSize
      }&take=${pageSize}`;
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );
    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(result.data);
      // Check if gridRef is defined and has the api property before using it
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.hideOverlay();
      }
    } else {
      setRowData([]);
    }
  };

  let check = true;
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);
  useEffect(() => {
    if (check) {
      if (loadingOverlayVisible) {
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.showLoadingOverlay();
        }
      }
      setLoadingOverlayVisible(true);
      const fecthDebounced = _.debounce(getData, 500);
      fecthDebounced();
      return () => {
        fecthDebounced.cancel();
      };
    }
    check = false;
  }, [currentPage, pageSize, filterCriteria]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);

  // const addData = (newData) => {
  //   console.log("Adding data:", newData);
  //   setRowData((prevData) => [...prevData, newData]);
  // };

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
    // setRowData((prevData) =>
    //   prevData.map((row) => (row === params.data ? updatedData : row))
    // );
    // console.log("Updated data:", updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
    // window.alert("selection changed, " + rowCount + " rows selected");
  }, []);

  const deleteRow = async (id) => {
    // setRowData((prevData) => prevData.filter((row) => row !== rowData));
    const message = "Do you want to delete this product details!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }

    let BASE_URL =
      SERVER_URL + `/api/product-details/product-details/${user_id}`;
    getData();
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
          // Retain the existing filter criteria values
        };
      });
      getData();
    } else {
      toast.error(response.message);
      getData();
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
          // Retain the existing filter criteria values
        };
      });
    }
  };

  const addDataToModal = async (rowData) => {
    setselectedRowsData(rowData);
  };

  const updateYard = async (rowData) => {
    setselectedRowsData(rowData);
  };
  const updateData = async (rowData) => {
    const { id, company_id, quantity, date, product_name_id } = rowData;
    const renewalDate = moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
    let BASE_URL =
      SERVER_URL + `/api/product-details/product-details/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id,
        quantity,
        date: renewalDate,
        product_name_id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);
  const CustomCellRenderer = (props) => {
    const { value } = props;
    // console.log("props", value)

    return <YardQtyDetails rowData={value} />;
  };
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => {
        const currentPageContext = params.context.currentPage;
        const pageSizeContext = params.context.pageSize;
        return (
          (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
        );
      },
      width: 100,
      minWidth: 100,
      // headerCheckboxSelection: true,
      // checkboxSelection: true,
    },
    {
      headerName: "Company",
      field: "companyDetails.company_name",
      valueFormatter: (params) => {
        const location = params.data.companyDetails.location;
        return `${params.value}, ${location}`;
      },
      editable: false,
      width: 250,
      minWidth: 205,
    },
    // {
    //   headerName: "Material Name",
    //   field: "raw_material.material_name",
    //   editable: false,
    //   width: 150,
    //   minWidth: 150,
    // },
    {
      headerName: "Product",
      field: "productName.size",
      editable: false,
      width: 150,
      minWidth: 150,
    },
    // {
    //   headerName: "Party Name",
    //   field: "partyName.party_name",
    //   valueFormatter: (params) => {
    //     // Assuming 'size' is another property in your data
    //     const location = params.data.company.location;
    //     return `${params.value} - ${location}`;
    //   },
    //   editable: false,
    //   width: 150,
    //   minWidth: 150,
    // },
    // {
    //   headerName: "Product Name",
    //   field: "product_name.product_name",
    //   valueFormatter: (params) => {
    //     // Assuming 'size' is another property in your data
    //     const location = params.data.product_name.size;
    //     return `${params.value} - ${location}`;
    //   },
    //   editable: true,
    //   width: 150,
    //   minWidth: 150,
    // },
    {
      headerName: "Quantity",
      field: "quantity",
      editable: true,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Mould Quantity",
      field: "in_mould_qty",
      cellRenderer: (params) => (
        <label className={`badge badge-secondary`} style={{ width: "100px" }}>
          {params.data.in_mould_qty}
        </label>
      ),
      editable: false,
      width: 150,
      minWidth: 150,
    },
    // {
    //   headerName: "Yard Quantity",
    //   field: "in_yard_qty_details",
    //   editable: false,
    //   cellRenderer: CustomCellRenderer,
    //   autoHeight: true,
    //   minWidth: 300,
    //   cellStyle: { display: "flex", alignItems: "center" },
    // },
    {
      headerName: "Yard Quantity",
      field: "in_yard_qty_details",
      editable: false,
      cellRenderer: (params) => {
        const totalYardQty = params.value?.reduce(
          (total, item) => total + parseInt(item.in_yard_qty),
          0
        );
        return (
          <label className={`badge badge-success`} style={{ width: "100px" }}>
            {totalYardQty ? totalYardQty : 0}
          </label>
        );
      },
      autoHeight: true,
      width: 150,
      minWidth: 150,
    },
    // {
    //   headerName: "Status",
    //   cellRenderer: (params) => (
    //     <label
    //       className={`badge ${
    //         params.data.is_in_yard == 1 ? "badge-success" : "badge-secondary"
    //       }`}
    //       style={{ width: "100px" }}
    //     >
    //       {params.data.is_in_yard == 1 ? "In Yard" : "Moulding"}
    //     </label>
    //   ),
    //   editable: false,
    //   width: 150,
    //   minWidth: 150,
    // },
    // {
    //   headerName: "Incoming Stock",
    //   field: "incoming_stock",
    //   editable: true,
    //   width: 150,
    //   minWidth: 150,
    // },
    {
      headerName: "Date",
      field: "date",
      editable: false,
      width: 150,
      minWidth: 150,
      cellEditor: "agDateStringCellEditor",
    },
    {
      headerName: "Actions",
      minWidth: 220,
      cellRenderer: (params) => {
        const totalYardQty = params.data.in_yard_qty_details?.reduce(
          (total, item) => total + parseInt(item.in_yard_qty),
          0
        );
        return (
          <>
            <button
              type="button"
              className="btn btn-outline-danger btn-sm"
              onClick={() => deleteRow(params.data.id)}
              title="Delete product detail"
              disabled={totalYardQty >= 0 ? true : false}
            >
              <i className="mdi mdi-delete" />
            </button>{" "}
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={() => addDataToModal(params.data)}
              data-toggle="modal"
              data-target="#updateProductModal"
              title="Update quantity of product"
            >
              <i className="mdi mdi-note-edit-outline" />
            </button>{" "}
            <button
              type="button"
              className="btn btn-outline-info btn-sm"
              onClick={() => updateYard(params.data)}
              data-toggle="modal"
              data-target="#updateYardModal"
              title={
                totalYardQty >= 0
                  ? "Update/View product's yard placement"
                  : "Place product to yard"
              }
            >
              {totalYardQty >= 0 ? (
                <>
                  <i className="mdi mdi-pencil-outline" />
                  {/* {" / "}
                  <i className="mdi mdi-eye-outline" /> */}
                </>
              ) : (
                <i className="mdi mdi-plus-outline" />
              )}
            </button>
          </>
        );
      },
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    flex: 1,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
    setfilterCriteria({ company_id: "", product_name_id: "", start_date: "", end_date:"" });
    setSelectedCompanyId("");
    setProductId("");
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });

  const getProductDetails = async (e) => {
    const companyId = e.target.value ? parseInt(e.target.value) : "";

    // Exit early if companyId is empty
    if (!companyId) {
      setProduct([]);
      // setProductId("");
      setfilterCriteria({ product_name_id: "" });
      setSelectedCompanyId(companyId);
      setfilterCriteria((prevFilterCriteria) => ({
        ...prevFilterCriteria,
        company_id: companyId,
      }));
      return;
    }
    setSelectedCompanyId(companyId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
      product_name_id: "",
      date: "",
    }));
    // setfilterCriteria({ product_name_id: "" });

    const BASE_URL = `${SERVER_URL}/api/product/drop-products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: companyId,
      }),
    });
    const result = await res.json();
    setProduct(result.data);
  };

  const handleProductChange = (e) => {
    const productId = e.target.value != "" ? parseInt(e.target.value) : "";
    // Update filterCriteria with the selected company's ID
    setProductId(productId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      product_name_id: productId,
    }));
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Products Details Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#productModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add Products
              </button>
            </div>

            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>
          <div className="search mb-3">
            <div className="row">
              {/* <div className="col-md-3">
                  <div className="form-group">
                  <Creatable
                              isClearable
                              onChange={handlePartyNameChange}
                              onCreateOption={handleCreate}
                              options={partyNameOptions}
                              value={selectedPartyName}
                              // menuIsOpen={true}
                              menuPosition="fixed"
                            />
                  </div>
                </div> */}
              <div className="col-md-3">
                <div className="form-group">
                <label htmlFor="company">Company Name</label>
                  <select
                    className="form-control form-control-lg"
                    onChange={(e) => getProductDetails(e)}
                    value={selectedCompanyId}
                  >
                    <option value="">Select Company (All)</option>
                    {company &&
                      company?.length > 0 &&
                      company?.map((item, id) => {
                        return (
                          <React.Fragment key={id}>
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.company_name}, ${item.location}`}</option>
                          </React.Fragment>
                        );
                      })}
                  </select>
                </div>
              </div>
              {selectedCompanyId && (
                <div className="col-md-3">
                  <div className="form-group">
                  <label htmlFor="product">Product Name</label>
                    <select
                      className="form-control form-control-lg"
                      onChange={handleProductChange}
                      value={productId}
                      id="product"
                    >
                      <option value="">Select Product (All)</option>
                      {product &&
                        product?.length > 0 &&
                        product?.map((item, id) => {
                          return (
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.size}`}</option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              )}
              {/* <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Search by party name"
                    onChange={(e) =>
                      handleFilterChange("party_name", e.target.value)
                    }
                  />
                </div> */}
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="start_date">From</label>
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    placeholder="Search from Date"
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      handleFilterChange("start_date", e.target.value)
                    }
                    value={filterCriteria.start_date}
                    id="start_date"
                    min={minDate}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="end_date">To</label>
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    placeholder="Search to Date"
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      handleFilterChange("end_date", e.target.value)
                    }
                    name="end_date"
                    value={filterCriteria.end_date}
                    min={minDate}
                    id="end_date"
                  />{" "}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 560 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                context={{ currentPage, pageSize }}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>
          <AddProductDetailsModal
            handleChange={handleChange}
            //   setimgfile={setimgfile}
            handleAddDataSubmit={handleAddDataSubmit}
            getData={getData}
            formRef={formRef}
          />
          <UpdateProductDetailsModal
            selectedRowsData={selectedRowsData}
            updateHandleChange={updateHandleChange}
            updateData={updateData}
            getData={getData}
          />
          <UpdateYardDetailsModal
            selectedRowsData={selectedRowsData}
            updateHandleChange={updateHandleChange}
            updateData={updateData}
            getData={getData}
            setselectedRowsData={setselectedRowsData}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default ProductDetails;
